package fyi.moko.hotpl.data.network

import fyi.moko.hotpl.domain.model.PhotoKind
import fyi.moko.hotpl.domain.model.PhotoRef
import kotlinx.serialization.Serializable

/**
 * 동기화용 사진 항목. 파일명만 오가고 바이트는 기기에 남는다
 * ([fyi.moko.hotpl.domain.model.PhotoRef] 참고).
 *
 * [kind]를 enum이 아니라 문자열로 두는 이유: 나중에 카테고리를 추가하면 그 값을 모르는 구버전
 * 클라이언트가 문서를 읽게 되는데, enum으로 두면 역직렬화가 통째로 실패한다. 문자열이면 모르는
 * 값이 null로 떨어지고 사진은 살아남는다 — 종류를 모르는 사진이 사진을 잃는 것보다 낫다.
 */
@Serializable
data class PhotoRefDto(
    val fileName: String,
    val kind: String? = null,
)

/**
 * 원격 문서의 사진 목록을 도메인으로 되살린다.
 *
 * 목록이 비어 있는데 [legacyImageFileName]이 있으면 **아직 이 필드를 모르는 클라이언트가 쓴
 * 문서**이므로 그 한 장짜리 목록으로 복원한다. 이게 없으면 구버전 기기에서 장소를 수정할 때마다
 * 신버전 기기의 사진 목록이 비워진다.
 */
fun List<PhotoRefDto>.toDomainPhotos(legacyImageFileName: String?): List<PhotoRef> =
    if (isNotEmpty()) {
        map { dto ->
            PhotoRef(
                fileName = dto.fileName,
                kind = dto.kind?.let { runCatching { PhotoKind.valueOf(it) }.getOrNull() },
            )
        }
    } else {
        listOfNotNull(legacyImageFileName?.takeIf { it.isNotBlank() }?.let { PhotoRef(it) })
    }
